
import { NAME_SOUND_HOVER, useGameSounds } from "@educaplay/core";
import classes from "./ButtonSend.module.scss"
import { Check } from "@educaplay/core/Icons/Check";
import clsx from "clsx";

export default function ButtonSend(props) {

    const { type = "submit", onClick, disabled, className } = props;
    const gameSound = useGameSounds();  

    return (
        <button className={clsx(classes.buttonPager, classes.buttonPager__send, className)} type={type} onClick={onClick} disabled={disabled}   onMouseEnter={() => gameSound.play(NAME_SOUND_HOVER)}>
            <span className={classes.buttonPager__icon}>
                <Check color={"#6EB118"} />
            </span>
        </button>
    )
}